module.exports = __webpack_public_path__ + "static/media/linkedin.20177402.svg";